import type { FormOptionType } from "@/components/ui/form/_types/type";

import * as Model from "../../../model";

export const RESERVATION_TYPE_OPTIONS: Array<FormOptionType> = [
	{
		id: Model.Constants.ReservationTypeForSearchReservationList.CHECK_IN,
		label: "チェックイン日",
		value: Model.Constants.ReservationTypeForSearchReservationList.CHECK_IN,
	},
	{
		id: Model.Constants.ReservationTypeForSearchReservationList.CHECK_OUT,
		label: "チェックアウト日",
		value: Model.Constants.ReservationTypeForSearchReservationList.CHECK_OUT,
	},
	{
		id: Model.Constants.ReservationTypeForSearchReservationList.STAY_DATE,
		label: "宿泊日",
		value: Model.Constants.ReservationTypeForSearchReservationList.STAY_DATE,
	},
	{
		id: Model.Constants.ReservationTypeForSearchReservationList.UPDATED_DATE,
		label: "最終更新日",
		value: Model.Constants.ReservationTypeForSearchReservationList.UPDATED_DATE,
	},
	{
		id: Model.Constants.ReservationTypeForSearchReservationList.RESERVATION_ID,
		label: "予約番号",
		value: Model.Constants.ReservationTypeForSearchReservationList.RESERVATION_ID,
	},
];
